/**
 * Clear user from reporters.
 */
import { clearUser } from 'lib/reporter/clearUser';
export const logoutSuccessHandler = (): void => {
  clearUser();
  return;
};
